export const PERMISSION_TYPES = Object.freeze({
  location: 0,
  health: 1,
  directPromotion: 2,
  aggregateData: 3,
  privacyPolicy: 4,
  ageConfirmation: 5,
  termsOfService: 6
});

export default PERMISSION_TYPES;
